import React from "react";
import { OverlayTrigger, Tooltip, Button } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import styles from "../../engagement_letter/ContentBlocksPage/components/ActionsRenderer/ActionsRenderer.module.css";
import { saveCOIRegistryEntry } from "./components/COIRegistryModal/COIRegistryModal.service";
import { AFFILIATE_TYPE_CODES, COIRegistryEntry } from "./COIRegistry.types";

export const AffiliateTypeRenderer = (props: any) =>
  props.value === AFFILIATE_TYPE_CODES.ENTITY ? "Entity" : "Individual";

export const YesNoRenderer = (props: any) =>
  props.value === "Y" ? "Yes" : "No";

export const BtnCellRenderer =
  (
    setSelectedRowData: React.Dispatch<React.SetStateAction<COIRegistryEntry | undefined>>,
    setModalShow: React.Dispatch<React.SetStateAction<boolean>>,
    loadEntries: () => Promise<void>
  ) =>
    (props: any) => {
      const handleDeactivateClick = async () => {
        const response = await saveCOIRegistryEntry({
          ...props.data,
          Active: "N",
        });
        if (response) {
          await loadEntries();
        }
      };

      return (
        <div>
          {props.data.Active === "Y" && (
            <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 400 }}
              overlay={<Tooltip id="button-tooltip">Delete entry</Tooltip>}
            >
              <span className={styles.tooltipWrapper}>
                <Button
                  className={`${styles.deleteActionButton} ${styles.actionButton}`}
                  onClick={handleDeactivateClick}
                >
                  <Icon.Trash />
                </Button>
              </span>
            </OverlayTrigger>
          )}
        </div>
      );
    };
